import angular from 'angular';
import controller from './jsoneditor.controller';
import template from './jsoneditor.html';
import JsonEditorComponent from './jsoneditor.component';

const jsoneditorConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('jsoneditor', {
		onEdit: /* @ngInject */     (/** @type {any} */ $scope) => {
			$scope.modes = [
				'tree',
				'view',
				'form',
				'code',
				'text',
			];

			// Toggle selection for a given mode by name
			$scope.toggleSelection = function toggleSelection(/** @type {any} */ mode, /** @type {string[]} */ modes) {
				const index = modes.indexOf(mode);

				// Is currently selected
				if (index > -1) {
					modes.splice(index, 1);
				}
				// Is newly selected
				else {
					modes.push(mode);
				}
			};
		},
		title:                      'JSON Editor',
		template,
		children:                   false,
		selectable:                 true,
		settings:                   new JsonEditorComponent(),
		icon:                       'fa fa-file-code-o',
		noDndOverlay:               true,
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/jsoneditor/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller,
	});
};

export default angular.module('app')
	.config(jsoneditorConfig);
